var _rect, _path, _path2, _path3, _polygon, _polygon2, _path4, _polygon3, _path5, _path6, _polygon4, _polygon5, _polygon6, _polygon7, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAmex(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.01,
    y: 0.45,
    width: 45.99,
    height: 30.1,
    rx: 3,
    fill: "#026fce"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93,23.67V16.45h7.65l.82,1.06.84-1.06H46v6.72a3.25,3.25,0,0,1-1.57.5H29.07l-.93-1.14v1.14h-3v-2A2.47,2.47,0,0,1,23.8,22h-1v1.67H18.18l-.82-1.1-.83,1.1Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,11,1.72,7h3l1,2.25V7h3.7L10,8.61,10.54,7H27.18V7.8A3.57,3.57,0,0,1,29.49,7l5.4,0,1,2.22V7H39l.85,1.28V7h3.13V14.2H39.81L39,12.92V14.2H34.43L34,13.07H32.75L32.3,14.2H29.21a3.06,3.06,0,0,1-2-.8v.8H22.52l-.93-1.13V14.2H4.26l-.45-1.13H2.59L2.13,14.2H0V11Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33,7.87,0,13.28H1.52L2,12.2h2.5l.42,1.08H6.42L4.1,7.87ZM3.2,9.13,4,11H2.43L3.2,9.13Z",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "6.58 13.28 6.58 7.87 8.73 7.88 9.98 11.37 11.21 7.87 13.34 7.87 13.34 13.28 11.99 13.28 11.99 9.29 10.56 13.28 9.37 13.28 7.93 9.29 7.93 13.28 6.58 13.28 6.58 13.28",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.27 13.28 14.27 7.87 18.68 7.87 18.68 9.08 15.63 9.08 15.63 10.01 18.61 10.01 18.61 11.14 15.63 11.14 15.63 12.11 18.68 12.11 18.68 13.28 14.27 13.28 14.27 13.28",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.46,7.87v5.41h1.35V11.36h.57L23,13.28h1.65l-1.77-2a1.64,1.64,0,0,0,1.48-1.66,1.75,1.75,0,0,0-1.89-1.76Zm1.35,1.21h1.55a.62.62,0,0,1,.64.57.61.61,0,0,1-.62.57H20.81V9.08Z",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "26.29 13.28 24.91 13.28 24.91 7.87 26.29 7.87 26.29 13.28 26.29 13.28",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.56,13.28h-.29A2.38,2.38,0,0,1,27,10.6a2.47,2.47,0,0,1,2.68-2.73h1.5V9.15H29.58a1.3,1.3,0,0,0-1.26,1.46,1.33,1.33,0,0,0,1.46,1.49h.35l-.57,1.18Z",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.51,7.87l-2.33,5.41h1.51l.43-1.08h2.5L35,13.28h1.55L34.27,7.87Zm.86,1.26L34.13,11H32.6l.77-1.89Z",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "36.75 13.28 36.75 7.87 38.47 7.87 40.66 11.27 40.66 7.87 42.02 7.87 42.02 13.28 40.35 13.28 38.1 9.79 38.1 13.28 36.75 13.28 36.75 13.28",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "9.86 22.74 9.86 17.34 14.27 17.34 14.27 18.54 11.22 18.54 11.22 19.47 14.2 19.47 14.2 20.61 11.22 20.61 11.22 21.57 14.27 21.57 14.27 22.74 9.86 22.74 9.86 22.74",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "31.47 22.74 31.47 17.34 35.88 17.34 35.88 18.54 32.84 18.54 32.84 19.47 35.8 19.47 35.8 20.61 32.84 20.61 32.84 21.57 35.88 21.57 35.88 22.74 31.47 22.74 31.47 22.74",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.44 22.74 16.59 20.07 14.39 17.34 16.09 17.34 17.4 19.03 18.71 17.34 20.35 17.34 18.18 20.04 20.33 22.74 18.63 22.74 17.36 21.08 16.12 22.74 14.44 22.74 14.44 22.74",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.49,17.34v5.4h1.39V21H23.3a1.87,1.87,0,0,0,2.12-1.89,1.78,1.78,0,0,0-1.94-1.81Zm1.39,1.22h1.5a.61.61,0,0,1,.67.62.63.63,0,0,1-.68.62H21.88V18.56Z",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17.33v5.41h1.35V20.82h.57l1.62,1.92H31.2l-1.78-2a1.64,1.64,0,0,0,1.48-1.66A1.75,1.75,0,0,0,29,17.33Zm1.35,1.21H28.9a.62.62,0,0,1,.64.57.61.61,0,0,1-.62.57H27.36V18.54Z",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.51,22.74V21.57h2.7c.4,0,.58-.22.58-.46s-.18-.45-.58-.45H38A1.51,1.51,0,0,1,36.34,19c0-.87.54-1.71,2.12-1.71h2.63l-.57,1.22H38.24c-.43,0-.56.23-.56.45a.47.47,0,0,0,.49.47h1.28A1.48,1.48,0,0,1,41.15,21a1.62,1.62,0,0,1-1.76,1.72Z",
    fill: "#026fce",
    fillRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.47,22.74V21.57h2.59c.4,0,.57-.22.57-.46s-.17-.45-.57-.45H43A1.51,1.51,0,0,1,41.3,19c0-.87.54-1.71,2.12-1.71H46l-.57,1.22H43.21c-.44,0-.57.23-.57.45a.47.47,0,0,0,.49.47H44.3A1.48,1.48,0,0,1,46,21a1.62,1.62,0,0,1-1.76,1.72Z",
    fill: "#026fce",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAmex);
export default __webpack_public_path__ + "static/media/ic_amex.32cf5c85b68abbed12bb002e3afdc56a.svg";
export { ForwardRef as ReactComponent };